import styled from "styled-components";
import {Box} from "@material-ui/core";

export const FullWidthFlexBox = styled(Box)`
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
`;